import Component from "@glimmer/component";
import DButton from "discourse/ui-kit/d-button";
import { i18n } from "discourse-i18n";

export default class PostMenuReadButton extends Component {
  static shouldRender(args) {
    return args.state.showReadIndicator && args.post.readers_count > 0;
  }

  <template>
    <div class="double-button">
      <DButton
        class="post-action-menu__read read-indicator button-count"
        ...attributes
        @action={{@buttonActions.toggleWhoRead}}
        @ariaPressed={{@state.isWhoReadVisible}}
        @title="post.controls.read_indicator"
        @translatedAriaLabel={{i18n
          "post.sr_post_read_count_button"
          count=@post.readers_count
        }}
      >
        {{@post.readers_count}}
      </DButton>
      <DButton
        ...attributes
        @action={{@buttonActions.toggleWhoRead}}
        @icon="book-open-reader"
        @title="post.controls.read_indicator"
      />
    </div>
  </template>
}
